<div class="container">
  <mat-card appearance="outlined" [ngClass]="{'no-visibility' : contentVisibility  === true ? true:false}">
    <mat-card-content>
      <h3>{{ dateOfBirthHeader ||' Make it personal'}}</h3>
      <p>{{ dateOfBirthDescription || ' Add your date of birth to display your own Initial Enrollment Period (IEP)
      in the timeline below' }}.</p>
      <p><b>{{ dateOfBirthInputLabel ||' What is your date of birth?' }}</b></p>
      <mat-form-field appearance="outline" class="dateTxt">
        <input class="dateField" placeholder="MM/DD/YYYY" matInput [matDatepicker]="picker"
          [(ngModel)]="selectedDOB" (dateChange)="getDate($event)" maxlength="10" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker startView='multi-year'></mat-datepicker>
          @if (isDateInvalid) {
            <mat-error [ngStyle]="{'color':'#f44336', 'font-weight':'bold'}">Please Enter Valid Date (MM/DD/YYYY)</mat-error>
          }
        </mat-form-field>
        <button class="btn_Personalize" mat-raised-button [disabled]="isDateInvalid" (click)="validateDate()">{{
        dateOfBirthInputButton||'PERSONALIZE' }}</button>
      </mat-card-content>
    </mat-card>
    <div class="timeline-wrap">
      <div class="cake-wrap">
        <div class="bodImage">
          <img src="{{ dateOfBirthImageUrl }}" title="" alt="" />
        </div>
        <div [ngClass]="{'no-visibility' : contentVisibility === true ? true:false}">
          <div class="sec-wrap">
            <div class="sec">
              @if (isMonthVisibile < 4) {
                <p>
                  @if (isVisibile) {
                    <b> {{threeMonthsBeforeDate | date : 'MMMM y' }} </b>
                  }
                </p>
              }
              @if (textHeight > 3) {
                <p>
                  <span class="hideText"> </span>
                </p>
              }
              <div class="dobText dobBfr">
                <div> {{ threeMonthsBeforeContent || "3 months before your birthday" }}</div>
              </div>
            </div>
            <div class="sec dobDiv">
              <p>@if (isVisibile) {
                <b class="brt_text"> {{dateOfBirth | date :'MMMM d, y' }}</b>
              }</p>
              @if (isMonthVisibile < 4) {
                <p>{{ birthdayLabel || "Your birthday"}}</p>
              }
              @if (isMonthVisibile > 3) {
                <p>{{ birthdayLabel || "Your Retirement Date"}}</p>
              }
            </div>
            <div class="sec dobAft">
              <p>@if (isVisibile) {
                <b> {{threeMonthsAfterDate | date : 'MMMM y' }}</b>
              }</p>
              <p class="dobText">{{ threeMonthsAfterContent || "3 months after your birthday" }}</p>
            </div>
          </div>
        </div>

        <div [ngClass]="{'no-visibility' : contentVisibility === true ? false:true}">
          <div class="sec-wrap switching">
            <div class="sec">
              <div class="  dobBfr">
                <div> {{ startExploring || "Start Exploring July / August" }}</div>
              </div>
            </div>
            <div class="sec dobDiv oeStart">

              <div> {{ openEnrollmentStarts || "Open Enrollment Starts October 15" }}</div>
            </div>
            <div class="sec dobAft">

              <div class=" ">{{ enrollmentPeriodEnds || "Enrollment Period Ends December 7" }}</div>
            </div>
          </div>
        </div>

        <div class="lineDiv">
          <div class="locationIcon">
            <span class="material-symbols-outlined">
              location_on
            </span>

          </div>
          <ul class="windowLines">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
          </ul>
          <div class="h-line"></div>
          <ul class="windowBoxs">
            <li class="emptBox"></li>
            <li class="emptBox"></li>
            <li class="boxBorder"></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li class="emptBox2"></li>
          </ul>
        </div>

        <div class="signup">Your window to sign up</div>
        <div class="signupMsg">
          <div class="signupMsgLeft">{{signUpContentLeft || "The best time to sign up as soon as you're
          eligible"}}</div>
          <div class="signupMsgRight">{{signUpContentRight || 'You my be personalized and wind up paying more
          later if you wait untill after you 65 birthday to sign up for coverage.'}}</div>
        </div>
      </div>
    </div>

  </div>
